import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, PageHeader, Row, Col, Button } from 'antd'
import Filters, { FilterItem, Types } from '../../components/Filters'
import BreedList from '../../components/BreedList'
import { BreedForm } from '../../components/Forms'
import { SpecieProvider, SpecieConsumer } from '../../context/SpecieContext'
import { BreedProvider, BreedConsumer } from '../../context/BreedContext'

export default class Breed extends Component {

  private breedFilterDispatchOptions = {
    search: {
      deleted: false,
      specie: {
        with: {
          _exists: true
        }
      }
    },
    options: {
      sort: ['name']
    }
  } as const

  breedListSearch = {
    search: {
      deleted: false,
      specie: {
        with: {
          _exists: true
        }
      }
    },
    options: {
      sort: ['name']
    }
  }

  handleFiltersSubmit = (payload: any) => {
    if (payload && payload.search) {
      this.breedListSearch.search = payload.search
    }
  }

  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to="breed/add">
        <Button type="primary" shape="round">
          Create new breed
        </Button>
      </Link>
    )
  }

  render() {
    const { permissions, history, goBack, match: { params: { breedUuid } } }: any = this.props

    return (
      <BreedProvider>
        <SpecieProvider>
          <SpecieConsumer>
            {({ fetching: fetchingSpecies, species, requestSpecieList }) => (
              <BreedConsumer>
                {({ fetching, error, breeds, breed, pagination, requestBreedList, requestBreedFind, requestBreedCreate, requestBreedUpdate, requestBreedDelete }) => {
                  
                  const speciesToFilter = !species ? [] : species.map(specie => {
                    return {
                      value: specie.uuid,
                      text: specie.name
                    }
                  })
                  // Edit user
                  if (breedUuid) {
                    let addon: any = {
                      data: breed,
                      permissions: permissions,
                      species: species
                    }
                    if (breedUuid !== 'add') {
                      addon = {
                        ...addon,
                        uuid: breedUuid
                      }
                    }
    
                    return (
                      <Card>
                        <PageHeader title={breedUuid === 'add' ? 'New Breed' : 'Edit Breed'} onBack={() => goBack('/admin/breed')}>
                          <BreedForm
                            {...addon}
    
                            loading={fetching}
                            contentLoading={fetchingSpecies}
                            
                            error={error}
                            history={history}
    
                            loadBreed={requestBreedFind}
                            loadSpecies={requestSpecieList}

                            dispatchCreate={requestBreedCreate}
                            dispatchUpdate={requestBreedUpdate}
                          />
                        </PageHeader>
                      </Card>
                    )
                  }
    
                  return (
                    <>
                      <Card title="Filters" style={{marginBottom: 25}}>
                        <Filters size="medium" loading={fetching || fetchingSpecies} history={history} defaultSubmitOptions={this.breedFilterDispatchOptions} submitDispatch={requestBreedList} dispatches={[requestSpecieList]} onSubmit={this.handleFiltersSubmit}>
                          {({ values, handleFilterChange }: any) => (
                            <Row gutter={9} style={{width: '100%'}}>
                              <Col xs={24} md={8}>
                                <FilterItem
                                  name="uuid"
                                  type={Types.INPUT}
                                  placeholder="Filter by UUID"
                                  value={values['uuid']}
                                  size="medium"
                                  options={{
                                    input: {
                                      allowClear: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
    
                              <Col xs={24} md={8}>
                                <FilterItem
                                  name="name.ilike"
                                  type={Types.INPUT}
                                  placeholder="Filter by Name"
                                  value={values['name.ilike']}
                                  size="medium"
                                  options={{
                                    input: {
                                      allowClear: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>

                              <Col xs={24} md={8}>
                                <FilterItem
                                  name="specie.with.uuid"
                                  type={Types.SELECT}
                                  placeholder="Species"
                                  value={values['specie.with.uuid']}
                                  data={speciesToFilter as any || []}
                                  size="medium"
                                  options={{
                                    select: {
                                      allowClear: true,
                                      showSearch: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
                            </Row>
                          )}
                        </Filters>
                      </Card>
    
                      <Card title="List of Breeds" extra={this.renderAdd()}>
                        <BreedList
                          loading={fetching}
                          breeds={breeds}
                          pagination={pagination}
                          permissions={permissions}
                          history={history}
                          searchOptions={this.breedListSearch}
                          loadBreeds={requestBreedList}
                          deleteBreed={requestBreedDelete}
                        />
                      </Card>
                    </>
                  )
                }}
              </BreedConsumer>
            )}
          </SpecieConsumer>
        </SpecieProvider>
      </BreedProvider>
    )
  }
}
